import React, { useRef } from 'react';
export function Bestsellers() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const products = [{
    name: 'Hybrid Cloudlux Leggings',
    price: '61.32',
    image: 'https://cdn.magicpatterns.com/uploads/vhs5b6eUmxBVAh5x1E8ZaA/pure-pulse-cloudlux.webp',
    colors: ['#FAF7F2', '#2B2420', '#A8957F']
  }, {
    name: 'Long Sleeve Workout Top',
    price: '15.09',
    image: 'https://cdn.magicpatterns.com/uploads/gR1wZ9AUAxWQTeWe9ZmN82/pure-pulse-long-sleeve.webp',
    colors: ['#9CAF88', '#A7C7DC', '#5C4033', '#2B2420', '#8A8A8A']
  }, {
    name: 'Pilates Crop Top',
    price: '12.61',
    image: 'https://cdn.magicpatterns.com/uploads/o332Bn988FXbAXHiBx94bh/pure-pulse-tops.webp',
    colors: ['#2B2420', '#FAF7F2', '#A8957F']
  }, {
    name: 'Pilates Grip Socks',
    price: '15.00',
    image: 'https://cdn.magicpatterns.com/uploads/chyRwzeC7fEiyUJBEg6soz/pure-pulse-grip-socks.webp',
    colors: ['#FFFFFF', '#F4C2C2', '#2B2420', '#C8B6E2']
  }];
  return <section className="py-16 md:py-24 px-6 bg-sand" data-id="element-20">
      <div className="max-w-7xl mx-auto" data-id="element-21">
        <div className="text-center mb-12" data-id="element-22">
          <p className="text-xs uppercase tracking-widest text-espresso mb-4" data-id="element-23">
            BESTSELLERS
          </p>
          <h2 className="font-serif font-light text-3xl md:text-4xl text-espresso" data-id="element-24">
            The pieces everyone loves.
          </h2>
        </div>

        <div ref={scrollRef} className="flex gap-6 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide md:grid md:grid-cols-4 md:overflow-visible" data-id="element-25">
          {products.map(product => <div key={product.name} className="flex-shrink-0 w-[280px] md:w-auto snap-start group" data-id="element-26">
              <div className="relative aspect-[3/4] mb-4 overflow-hidden" data-id="element-27">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-28" />
                <button className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-cream text-espresso px-6 py-3 rounded-full text-sm uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity duration-300 min-h-[44px]" data-id="element-29">
                  Quick Add
                </button>
              </div>
              <h3 className="text-espresso mb-1" data-id="element-30">{product.name}</h3>
              <p className="text-espresso font-medium mb-2" data-id="element-31">${product.price}</p>
              <div className="flex gap-2" data-id="element-32">
                {product.colors.map((color, idx) => <button key={idx} className="w-6 h-6 rounded-full border border-espresso/20" style={{
              backgroundColor: color
            }} aria-label={`Color option ${idx + 1}`} data-id="element-33" />)}
              </div>
            </div>)}
        </div>

        <div className="text-center mt-12" data-id="element-34">
          <a href="#" className="inline-block text-espresso uppercase tracking-widest text-sm border-b border-rust pb-1 hover:text-rust transition-colors" data-id="element-35">
            VIEW ALL PRODUCTS
          </a>
        </div>
      </div>
    </section>;
}